__webpack_require__.p = "/knowledge-base/";